export default {
  title: 'Zaloguj się',
  type: 'object',
  properties: {
    login: {
      title: 'Login',
      type: 'string',
      fieldRequired: true
    },
    password: {
      title: 'Hasło',
      type: 'string',
      fieldRequired: true
    }
  }
};
